import AccountCreationAdmin from '@/components/AccountCreationAdmin';
import AccountCreationOrganization from '@/components/AccountCreationOrganization';
import AccountDetail from '@/components/AccountDetail';
import EditIndividualAccount from '@/components/EditIndividualAccount';
import EditInstitutionAccount from '@/components/EditInstitutionAccount';
import EditTrustAccount from '@/components/EditTrustAccount';
import EditJointAccount from '@/components/EditJointAccount';
import FailedTransactionDetail from '@/components/FailedTransactionDetail';
import FailedTransactions from '@/components/FailedTransactionList';
import AdminSettings from '@/components/AdminSettings';
import IRAdmin from '@/components/IRAdmin';
import NoteDetail from '@/components/NoteDetail';
import PurchaseInvestmentNote from '@/components/PurchaseInvestmentNote';
import Redeem from '@/components/Redeem';
import FailTransaction from '@/components/FailTransaction';
import Transfer from '@/components/Transfer';
import AddFunds from '@/components/AddFunds';
import UserCreationByAdmin from '@/components/UserCreationByAdmin';
import UserDetail from '@/components/UserDetail';
import EditFinancialAdvisor from '@/components/EditFinancialAdvisor';
import Users from '@/components/Users';
import RetryPayment from '@/components/RetryPayment';

const adminRoutes = [
  {
    path: '/transactions',
    name: 'FailedTransactionList',
    component: FailedTransactions,
  },
  {
    path: '/settings',
    name: 'AdminSettings',
    component: AdminSettings,
  },
  {
    path: '/users',
    name: 'Users',
    component: Users,
  },
  {
    path: '/admin',
    name: 'IRAdmin',
    component: IRAdmin,
  },
  {
    path: '/user-creation-by-admin',
    name: 'UserCreationByAdmin',
    component: UserCreationByAdmin,
  },
  {
    path: '/users/:name/user-detail/:userId/account-creation-admin/:accountType',
    name: 'AccountCreationAdmin',
    component: AccountCreationAdmin,
  },
  {
    path: '/users/:name/user-detail/:userId',
    name: 'UserDetail',
    component: UserDetail,
  },
  {
    path: '/users/:name/edit-financial-advisor/:userId',
    name: 'EditFinancialAdvisor',
    component: EditFinancialAdvisor,
  },
  {
    path: '/users/:name/user-detail/:userId/account-detail/:accountId/purchase-investment-note',
    name: 'PurchaseInvestmentNote',
    component: PurchaseInvestmentNote,
  },
  {
    path: '/users/:name/user-detail/:userId/account-detail/:accountId',
    name: 'AccountDetail',
    component: AccountDetail,
  },
  {
    path: '/users/:name/user-detail/:userId/individual-account-detail/:accountId',
    name: 'EditIndividualAccount',
    component: EditIndividualAccount,
  },
  {
    path: '/users/:name/user-detail/:userId/institution-account-detail/:accountId',
    name: 'EditInstitutionAccount',
    component: EditInstitutionAccount,
  },
  {
    path: '/users/:name/user-detail/:userId/trust-account-detail/:accountId',
    name: 'EditTrustAccount',
    component: EditTrustAccount,
  },
  {
    path: '/users/:name/user-detail/:userId/joint-account-detail/:accountId',
    name: 'EditJointAccount',
    component: EditJointAccount,
  },
  {
    path: '/users/:name/user-detail/:userId/note-detail/:noteId',
    name: 'NoteDetail',
    component: NoteDetail,
  },
  {
    path: '/users/:name/user-detail/:userId/accounts/:accountId/redeem/:noteId',
    name: 'Redeem',
    component: Redeem,
  },
  {
    path: '/users/:name/user-detail/:userId/note-detail/:noteId/fail-transaction/:transactionId',
    name: 'FailTransaction',
    component: FailTransaction,
  },
  {
    path: '/users/:name/user-detail/:userId/transfer/:noteId',
    name: 'Transfer',
    component: Transfer,
  },
  {
    path: '/users/:name/user-detail/:userId/add-funds/:noteId',
    name: 'AddFunds',
    component: AddFunds,
  },
  {
    path: '/users/:name/user-detail/:userId/account-creation-organization/:accountType',
    name: 'AccountCreationOrganization',
    component: AccountCreationOrganization,
  },
  {
    path: '/transaction-detail/:id',
    name: 'FailedTransactionDetail',
    component: FailedTransactionDetail,
  },
  {
    path: '/transaction/retry',
    name: 'RetryFailedTransaction',
    component: RetryPayment,
  },
];

const adminRoutesMeta = {
  meta: {
    requiresIrAdminRole: true,
  },
};

export default adminRoutes.map((route) => {
  const routeWithMetadata = Object.assign(route, adminRoutesMeta);
  return routeWithMetadata;
});



// WEBPACK FOOTER //
// ./src/router/irAdmin.js